function imageViewUrl (rawUrl) {
  return rawUrl && rawUrl.startsWith('data:') && rawUrl
    || rawUrl && rawUrl.startsWith('http') && rawUrl
    // eslint-disable-next-line no-undef
    || rawUrl && `${($config || {})['VUE_APP_IMAGE_BASE_URL'] || process.env.VUE_APP_IMAGE_BASE_URL}/${rawUrl}`;
}

function getByteLength (input) {
  return input && input.split('').map(s => s.charCodeAt(0)).reduce((prev, c) => {
    return (prev + ((c === 10) ? 2 : ((c >> 7) ? 2 : 1)));
  }, 0) || 0;
}

export {
  imageViewUrl,
  getByteLength,
};
